import { render, staticRenderFns } from "../../assets/templates/StartPlataformas/FlowPage.html?vue&type=template&id=683b5060&scoped=true&"
import script from "../../assets/scripts/StartPlataformas/FlowPage.js?vue&type=script&lang=js&"
export * from "../../assets/scripts/StartPlataformas/FlowPage.js?vue&type=script&lang=js&"
import style0 from "../../assets/scss/flowPage.scss?vue&type=style&index=0&id=683b5060&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683b5060",
  null
  
)

export default component.exports